// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__A1pHR","title":"Images45_title__29DBj","images":"Images45_images__1nxTq"};